import { render } from "./ErrorBox.vue?vue&type=template&id=531e452e"
import script from "./ErrorBox.vue?vue&type=script&lang=js"
export * from "./ErrorBox.vue?vue&type=script&lang=js"

import "./ErrorBox.vue?vue&type=style&index=0&id=531e452e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__